import * as z from 'zod';

import { type SelectOption } from '@/_components/form-components/select/types';

const locationsZod = z.object({
  name: z.string(),
  value: z.enum([
    '',
    'USA - Northern Virginia',
    'USA - Northern California',
    'USA - Ohio',
    'USA - Oregon',
    'Canada - Montreal',
    'EU - Ireland',
    'EU - Frankfurt',
    'EU - London',
    'Europe - Paris',
    'Europe - Milan',
    'Europe - Stockholm',
    'Asia Pacific - Singapore',
    'Asia Pacific - Sydney',
    'Asia Pacific - Seoul',
    'Asia Pacific - Mumbai',
    'Asia Pacific - Hong Kong',
    'South America - Sao Paulo',
    'Middle East - Bahrain',
    'Africa - Cape Town',
  ]),
});

type TLocations = z.infer<typeof locationsZod>;

const defaultStatus: TLocations = { name: 'None', value: '' } as const;

export const locationsOptions: SelectOption<TLocations['value']>[] = [
  {
    name: 'USA - Northern Virginia',
    value: 'USA - Northern Virginia',
  },
  {
    name: 'USA - Northern California',
    value: 'USA - Northern California',
  },
  {
    name: 'USA - Ohio',
    value: 'USA - Ohio',
  },
  {
    name: 'USA - Oregon',
    value: 'USA - Oregon',
  },
  {
    name: 'Canada - Montreal',
    value: 'Canada - Montreal',
  },
  {
    name: 'EU - Ireland',
    value: 'EU - Ireland',
  },
  {
    name: 'EU - Frankfurt',
    value: 'EU - Frankfurt',
  },
  {
    name: 'EU - London',
    value: 'EU - London',
  },
  {
    name: 'Europe - Paris',
    value: 'Europe - Paris',
  },
  {
    name: 'Europe - Milan',
    value: 'Europe - Milan',
  },
  {
    name: 'Europe - Stockholm',
    value: 'Europe - Stockholm',
  },
  {
    name: 'Asia Pacific - Singapore',
    value: 'Asia Pacific - Singapore',
  },
  {
    name: 'Asia Pacific - Sydney',
    value: 'Asia Pacific - Sydney',
  },
  {
    name: 'Asia Pacific - Seoul',
    value: 'Asia Pacific - Seoul',
  },
  {
    name: 'Asia Pacific - Mumbai',
    value: 'Asia Pacific - Mumbai',
  },
  {
    name: 'Asia Pacific - Hong Kong',
    value: 'Asia Pacific - Hong Kong',
  },
  {
    name: 'South America - Sao Paulo',
    value: 'South America - Sao Paulo',
  },
  {
    name: 'Middle East - Bahrain',
    value: 'Middle East - Bahrain',
  },
  {
    name: 'Africa - Cape Town',
    value: 'Africa - Cape Town',
  },
];

export function locationSchema() {
  return locationsZod.refine(({ value }) => value !== '', {
    message: "Location can't be None",
  });
}

export function strToLocation(str: string): TLocations {
  return locationsOptions.find((item) => item.value === str) ?? defaultStatus;
}
